<template>
  <v-container fluid grid-list-lg>
    <EditFee :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editStudent="selectedStudent">
    </EditFee>

    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="!ClassRoomId" :access="!ClassRoomId" title="Student" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table hide-default-footer :headers="headers" :items="students" :search="search" :loading="loading"
        :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer" v-if="item.Student">
            <td class="text-left">
              <span class="text-capitalize">{{ item.Student.fullName }}</span>

              <v-chip v-if="item.classCount === 0" small color="pink" text-color="white" class="ml-2 font-weight-bold"
                label>
                Class Not Assigned
              </v-chip>
            </td>
            <td class="text-left text-decoration-underline blue--text" v-if="!item.StudentCustomerId"
              @click="viewProfile(item.Student.CustomerId)">
              <div v-if="item.Student.Customer">{{ item.Student.Customer.name }}</div>
            </td>
            <td class="text-left">{{ item.Student.reference }}</td>
            <!-- <td class="text-right">{{ item.fee | currency }}</td>
            <td class="text-right">{{ item.discount | currency }}</td> -->
            <!-- <td class="text-right">{{ item.parentPay | currency }}</td> -->
            <!-- <td class="text-right">{{ item.sponsor | currency }}</td> -->
            <!-- <td class="text-left">{{ item.Customer.name }}</td> -->
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <!-- ksiddiqui3@gmail.com -->
                  <!-- <v-list-item
                    v-if="!item.StudentTeachers.length"
                    @click="assignTeacher(item)"
                  >
                    <v-list-item-title>Assign Teacher</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.classCount === 0"
                    @click="assignClass(item)"
                  >
                    <v-list-item-title>Assign Department</v-list-item-title>
                  </v-list-item>
                   -->

                  <v-list-item v-if="checkRightStatus(18)" @click="editStudent(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="checkRightStatus(10)" @click="deleteStudent(item)">
                    <v-list-item-title>Remove From Class Room</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr v-else>
            Student is removed: {{ item.id }}
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import studentService from "../service";
import { mapGetters } from "vuex";

const EditFee = () => import("@/modules/Student/components/EditFee.vue");

export default {
  props: {
    ClassRoomId: {
      default: null,
    },
    showAll: {
      default: false,
    },
    // due: {
    //   default: false,
    // },
  },
  name: "classroom-student-list",
  data() {
    return {
      assignTeachDialog: false,
      assignClassDialog: false,
      createDialog: false,
      editDialog: false,
      selectedStudent: null,
      headers: [],
      students: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Student List";
    this.headers.push({
      text: this.$t("labels.name"),
      align: "left",
      value: "name",
      sortable: true,
    });

    if (!this.CustomerId) {
      this.headers.push({
        text: "Parent",
        align: "left",
        value: "Customer.name",
        sortable: true,
      });
    }
    this.headers.push(
      {
        text: "Reference",
        value: "reference",
        sortable: true,
      },
      // {
      //   text: "Fee",
      //   align: "right",
      //   value: "fee",
      //   sortable: true,
      // },
      // {
      //   text: "Discount",
      //   value: "discount",
      //   align: "right",
      //   sortable: true,
      // },
      {
        text: "Parent Will Pay",
        align: "right",
        value: "parentPay",
        sortable: true,
      },
      // {
      //   text: "Sponsor",
      //   align: "right",
      //   value: "sponsor",
      //   sortable: true,
      // },
      {
        text: "",
        value: "action",
        sortable: false,
      }
    );
  },
  components: {
    EditFee,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    assignClassSubmit() {
      this.assignClassDialog = false;
      this.getList();
    },
    assignSubmit() {
      this.assignTeachDialog = false;
      this.getList();
    },
    viewProfile(id) {
      this.$router.push({ path: `/parents/${id}/profile` });
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false
      this.createDialog = false
      let where = {};
      if (this.ClassRoomId) {
        where.ClassRoomId = this.ClassRoomId;
      }
      return studentService.getStudentByClassRoomId(where).then((response) => {
        console.log("response", response);
        this.loading = false;
        this.students = response.data;
        this.itemsPerPage = this.students.length
        return response;
      });
    },
    editStudent(obj) {
      this.selectedStudent = obj;
      this.editDialog = !this.editDialog;
    },
    assignTeacher(obj) {
      this.selectedStudent = obj;
      this.assignTeachDialog = !this.assignTeachDialog;
    },
    assignClass(obj) {
      this.selectedStudent = obj;
      this.assignClassDialog = !this.assignClassDialog;
    },
    deleteStudent(obj) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          studentService.removeStudentFromClassRoom(obj.id).then((response) => {
            if (response.data) {
              this.$swal("Removed!", "Student has been remove from classroom.", "success");
              this.$emit('getList');
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
